module.exports = __webpack_public_path__ + "img/icon_422A8581_2048px.54c7e51f.jpg";